export default "__VITE_ASSET__F4s$Rore__"